const ErrorPage = () =>{
    return(
        <div className="error-div">
            <h1>Oops! Something went wrong.</h1>
        </div>
    )
}

export default ErrorPage